'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _grid = require('../grid');

exports["default"] = _grid.Row;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/row/index.tsx
 ** module id = 155
 ** module chunks = 0
 **/